class TabbedContent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.tabs = this.querySelectorAll('[slot="tabs"] button[role="tab"]');
    this.panels = this.querySelectorAll('[slot="panels"] section[role="tabpanel"]');

    // Handle tab switching (no need to set initial attributes - already in HTML)
    this.tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        this.activateTab(tab);
      });
      tab.addEventListener("keydown", (e) => this.handleKeydown(e, this.tabs));
    });
  }

  activateTab(selectedTab) {
    if (!(selectedTab instanceof HTMLElement)) {
      selectedTab = Array.from(this.tabs).find(tab => tab.id === selectedTab);
    };

    this.tabs.forEach((tab) => {
      const isActive = tab === selectedTab;
      tab.setAttribute("aria-selected", isActive);
      tab.tabIndex = isActive ? 0 : -1;
      tab.classList.toggle("active", isActive);
    });

    this.panels.forEach((panel) => {
      const isActive = panel.id === selectedTab.getAttribute("aria-controls");
      panel.classList.toggle("active", isActive);
      panel.classList.toggle("z-10", isActive);
      panel.classList.toggle("opacity-0", !isActive);
      panel.classList.toggle("pointer-events-none", !isActive);
    });
  }

  handleKeydown(e, tabs) {
    const currentIndex = [...tabs].indexOf(document.activeElement);
    let newIndex = null;

    if (e.key === "ArrowRight") newIndex = (currentIndex + 1) % tabs.length;
    if (e.key === "ArrowLeft") newIndex = (currentIndex - 1 + tabs.length) % tabs.length;

    if (newIndex !== null) {
      tabs[newIndex].focus();
      tabs[newIndex].click();
    }
  }
}

customElements.define("tabbed-content", TabbedContent);
